export enum Services {
    EnergyStop = 'energy-stop',
    EnergyStart = 'energy-start',
    Water = 'water',
    WaterFinalInvoice = 'water-final-invoice',
    WaterNewContract = 'water-new-contract',
}
